import { NavigationMenu } from '~/navigation_menu/NavigationMenu'
import { Box, Flex } from '~/design_system'
import { BaseLayout } from './BaseLayout'
import { Footer } from './Footer'

export const MainLayout = ({ children }) => {
  return (
    <Flex flexDirection="column" minHeight="100vh">
      <BaseLayout />
      {/* eslint-disable-next-line no-nested-ternary */}
      <NavigationMenu />
      <Box
        flexGrow={1}
        sx={{
          '.assistant-open &': {
            marginRight: '372px',
            transition: 'margin-right 0.3s ease-in-out'
          }
        }}>
        {children}
      </Box>
      <Footer />
    </Flex>
  )
}
